import React from 'react';
import PageWrapper from '@erkport/components/PageWrapper';
import {getMonths, getYears} from '@erkport/services/erkport';
import CityMapPage from './page';

const CityMap = () => {
  return (
    <PageWrapper yearsProvider={getYears} monthsProvider={getMonths}>
      {(props) => <CityMapPage {...props} />}
    </PageWrapper>
  );
};

export default CityMap;
